module.exports = __webpack_public_path__ + "img/settingsIcon.b30cf00c.svg";